// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__1kg4-","screen":"Video_screen__1lJ-y","inner":"Video_inner__1Acu1","play":"Video_play__12s6f","content":"Video_content__1L4di"};